import { getCOI } from "../../../../../lib/api";

const loader = async ({ params }: any) => {
    const { teamId } = params;
    const { coi } = await getCOI(teamId);

    return {
        teamId,
        coi,
    };
};

export default loader;
